import { Typography } from '@bgzt/ui';
import { Fragment, type ReactNode } from 'react';
import { Image, Spacing } from '~/components';
import IcMercariBenefitLogo from '~/public/assets/icons/ic_mercari_benefit_logo.svg';
import styles from './Benefit.module.scss';

type Props = {
  iconUrl: string | 'mercari-static';
  title: string;
  titleBadge?: ReactNode;
  contents: ReactNode[];
  moreContents?: ReactNode[];
};

/** 상품 혜택 영역 */
export const Benefit = ({ iconUrl, title, titleBadge, contents, moreContents }: Props) => {
  return (
    <div className={styles.wrapper}>
      {iconUrl === 'mercari-static' ? (
        <IcMercariBenefitLogo />
      ) : (
        <Image
          src={iconUrl}
          alt={`${title} 로고`}
          width={30}
          height={30}
          placeholder="empty"
          className={styles.icon}
          unoptimized
        />
      )}

      <details className={styles.details}>
        <summary>
          <Typography variant="S4" as="p" color="gray-900">
            {title}
            {titleBadge && titleBadge}
          </Typography>
          {contents.map((content, index) => (
            <Fragment key={index}>
              <Spacing height={4} />
              <Typography variant="C2" as="div" color="gray-700">
                {content}
              </Typography>
            </Fragment>
          ))}
          {moreContents && (
            <Typography variant="C2" as="p" color="gray-700">
              <em>더보기</em>
            </Typography>
          )}
        </summary>
        {moreContents?.map((content, index) => (
          <Fragment key={index}>
            <Spacing height={4} />
            <Typography variant="C2" as="p" color="gray-700">
              {content}
            </Typography>
          </Fragment>
        ))}
      </details>
    </div>
  );
};
